import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import { useSessionInfo } from "./SessionInfo";
var styles = function styles(theme) {
  return {
    productName: {
      color: theme.palette.primary.main
    },
    contextDetails: {
      color: theme.palette.text.secondary
    }
  };
};
function SessionInfoFooter(_ref) {
  var classes = _ref.classes;
  var _useSessionInfo = useSessionInfo(),
    _useSessionInfo2 = _slicedToArray(_useSessionInfo, 2),
    sessionInfo = _useSessionInfo2[0],
    setSessionInfo = _useSessionInfo2[1];
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React.createElement(Box, {
    p: 0.5
  }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("div", {
    className: classes.productName
  }, sessionInfo && sessionInfo.productName))), /*#__PURE__*/React.createElement(Box, {
    p: 0.5
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.productName
  }, sessionInfo && sessionInfo.version)), /*#__PURE__*/React.createElement(Box, {
    p: 0.5
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.contextDetails
  }, sessionInfo && sessionInfo.contextDetails, " | ", sessionInfo && sessionInfo.username)));
}
export default withStyles(styles)(SessionInfoFooter);